import { useWidgetParam } from '@src/core/hooks';
import useFeatureFlag from './useFeatureFlag';

export const usePackageIdParam = () => {
  const packageId = useWidgetParam('product-package-id');

  const { isFeatureFlagEnabled } = useFeatureFlag();
  const isActiveFeature = isFeatureFlagEnabled('PR-646-product-packages');

  return isActiveFeature ? packageId : undefined;
};

export default usePackageIdParam;
